import { render, staticRenderFns } from "./AccountProfileChangeSubscriptionAddress.vue?vue&type=template&id=4a64eb7c&"
import script from "./AccountProfileChangeSubscriptionAddress.vue?vue&type=script&lang=js&"
export * from "./AccountProfileChangeSubscriptionAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports